import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationStart } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';
import { ModalService } from '../../Services/modal/modal.service';
import { AuthModalComponent } from '../../Components/auth/auth-modal/auth-modal.component';
import { AuthenticationService } from '../../Services/authentication/authentication.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { MixpanelService } from '../mixpanel/mixpanel.service';

@Injectable()
export class AuthguardService implements CanActivate {

  returnURL: string;
  queryParams: any;
  private isLoginModalOpen = false;

  constructor(
    private router: Router,
    private modalService: ModalService,
    private location: Location,
    private authService: AuthenticationService,
    @Inject(PLATFORM_ID) private platform: Object,
    private mixpanel: MixpanelService ,
    private analytics: AnalyticsService,

    ) {
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (this.isLoginModalOpen) {
            this.removeModal();
          }
        }
      });
    }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const stateUrl = state.url;
    if (stateUrl.indexOf('/passengers?') >= 0) {
      return true;
    }
    if (stateUrl.indexOf('/extras?') >= 0) {
        return true;
    }
    // this.returnURL = route.routeConfig.path;
    if (stateUrl.indexOf('?') > 0) {
      this.returnURL = stateUrl.substring(0, stateUrl.indexOf('?'));
      this.queryParams = route.queryParams;
    } else {
      this.returnURL = stateUrl;
    }
    if (this.authService.isLoggedIn()) {
      if (this.queryParams && this.queryParams.token) {
        if (this.authService.getUserToken() === this.queryParams.token) {
          return true;
        } else {
          if (this.queryParams.token) {
            this.authService.getUser(this.queryParams.token).subscribe(
              resp => {
                this.router.navigate([this.returnURL], { queryParams: this.queryParams});
                return true;
              },
              err => {
                this.initLoginModal();
                return false;
              }
            );
          } else {
            this.authService.logout().subscribe(
              resp => {
                this.initLoginModal();
                return false;
              },
              err => {
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                this.initLoginModal();
                return false;
              });
          }
        }
      }
      return true;
    } else if (this.queryParams && this.queryParams.token) {
      this.authService.getUser(this.queryParams.token).subscribe(
        resp => {
          this.router.navigate([this.returnURL], { queryParams: this.queryParams});
          return true;
        },
        err => {
          this.initLoginModal();
          return false;
        }
      );
    } else {
      this.initLoginModal();
      return false;
    }
    // this.router.navigate(['auth/login'], { queryParams: {returnUrl: state.url} });
  }

  public initLoginModal() {
    this.isLoginModalOpen = true;
    const inputs = {
      isMobile: false,
      returnURL: this.returnURL,
      queryParams: this.queryParams,
      closeURL: '/'
    };
    this.modalService.init(AuthModalComponent, inputs, {});
    if (isPlatformBrowser(this.platform)) {
      document.getElementById('modalContainer').style.zIndex = '110';
    
      if(localStorage.getItem('checkout_params')){
        const checkout_params = JSON.parse(localStorage.getItem('checkout_params'));
        this.analytics.logEvent('checkout_error', {
          ...checkout_params,
          date: new Date().toString(),
          reason: 'User token is invalid'
        });
        this.mixpanel.track('checkout_error', {
          ...checkout_params,
          date: new Date().toString(),
          reason: 'User token is invalid'
        });

        localStorage.removeItem('checkout_params');
      }
    }
  }

  public removeModal() {
    this.isLoginModalOpen = false;
    this.modalService.destroy();
  }

}
